var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mapGetters, mapActions } from "vuex";
import * as SearchParams from "search-params";
import * as Screenshare from "../screenshare";
import createLog from "../log";
import adapter from "webrtc-adapter";
var VideoOriginal = "video[data-original]";
var VideoScreen = "video[data-screen]";
var log = createLog("stream");
function toggleTrack(tracksGetter) {
    var track = tracksGetter()[0];
    if (!track) {
        console.error("No track found", tracksGetter);
        return;
    }
    return (track.enabled = !track.enabled);
}
// label argument is for debug only
function setVideoElementSource($el, source, isLocal, label) {
    var videoElement = $el.querySelector(VideoOriginal);
    if (isLocal) {
        videoElement.muted = true;
        videoElement.onloadedmetadata = function () {
            log("Local resolution: " + videoElement.videoWidth + "x" + videoElement.videoHeight);
        };
    }
    if (videoElement.srcObject && source && videoElement.srcObject.id === source.id) {
        return;
    }
    log("Setting new stream for", label, ":", source.id);
    videoElement.srcObject = source;
}
function setVideoElementScreenSource($el, screenSource, isLocal, label) {
    var videoElement = $el.querySelector(VideoScreen);
    if (isLocal) {
        videoElement.muted = true;
        videoElement.onloadedmetadata = function () {
            log("Local resolution: " + videoElement.videoWidth + "x" + videoElement.videoHeight);
        };
    }
    if (videoElement.srcObject && screenSource && videoElement.srcObject.id === screenSource.id) {
        return;
    }
    log("Setting new stream for", label, ":", screenSource.id);
    videoElement.srcObject = screenSource;
}
function lockElementHeight(videoElement) {
    var firstVideoElement = document.querySelector("[container] " + VideoOriginal);
    if (firstVideoElement && firstVideoElement !== videoElement) {
        var height = firstVideoElement.offsetHeight;
        //videoElement.setAttribute('style', `height: ${height}px`);
    }
}
function freeElementHeight(videoElement) {
    videoElement.removeAttribute("style");
}
function attachCanPlayEvent() {
    var _this = this;
    var videoElement = this.$el.querySelector(VideoOriginal);
    lockElementHeight(videoElement);
    var onCanPlay = function () {
        freeElementHeight(videoElement);
        _this.isVideoReady = true;
        videoElement.removeEventListener("canplay", onCanPlay);
    };
    videoElement.addEventListener("canplay", onCanPlay);
}
export default {
    name: "stream",
    props: ["source", "screenSource", "label", "isLocalStream", "id", "peer", "localInitialMode"],
    watch: {
        source: {
            handler: function (currentStream) {
                if (!currentStream) {
                    console.error("Stream empty for " + this.userName);
                    return;
                }
                setVideoElementSource(this.$el, currentStream, this.isLocalStream, this.userName);
            },
        },
        localStreamUpdated: {
            handler: function (updated) {
                if (!updated || !this.source)
                    return;
                var videoTrack = this.source.getVideoTracks()[0];
                if (videoTrack) {
                    videoTrack.enabled = this.videoEnabled;
                }
                var audioTrack = this.source.getAudioTracks()[0];
                if (audioTrack) {
                    audioTrack.enabled = this.audioEnabled;
                }
                this.$store.commit("localStreamUpdated", false);
            }
        },
        screenSource: {
            handler: function (screenStream) {
                if (!screenStream)
                    return;
                setVideoElementScreenSource(this.$el, screenStream, this.isLocalStream, this.userName);
            }
        },
        locale: function (val) {
            this.$i18n.locale = val;
        },
    },
    data: function () {
        return {
            isLive: false,
            isAudioMuted: false,
            isVideoReady: false,
            videoEnabled: true,
            remoteAudioEnabled: true,
            showBitrate: false,
            bitrate: 0,
            isChrome: adapter.browserDetails.browser === "chrome",
        };
    },
    computed: __assign(__assign({}, mapGetters(["chatFeatureEnabled", "showNewMessageIndicator", "localStreamUpdated", "sharingScreenOnly", "supportSimultaneousScreen"])), { streamClass: function () {
            if (this.localInitialMode) {
                return "local-initial";
            }
            return this.isLocalStream ? "local" : "remote";
        },
        userName: function () {
            if (this.isLocalStream)
                return this.$store.getters.localUserName;
            return this.label;
        },
        isSuspended: function () {
            if (this.isLocalStream)
                return false;
            return this.peer.isSuspended;
        },
        isTallyActive: function () {
            if (this.$store.getters.appState !== "connected")
                return false;
            if (!this.isLocalStream)
                return false;
            return this.isLive;
        },
        isScreenShare: function () {
            if (this.screenSource)
                return true;
            return false;
        },
        isRemoteAudioMuted: function () {
            if (this.$store.getters.appState !== "connected")
                return false;
            if (this.isLocalStream)
                return false;
            return this.isAudioMuted;
        },
        showChatIcon: function () {
            return this.localInitialMode !== true && this.isLocalStream && this.chatFeatureEnabled;
        },
        videoFlipped: function () {
            return this.$store.getters.videoFlipped;
        }, audioEnabled: {
            get: function () {
                if (this.isLocalStream) {
                    return this.$store.getters.localAudioEnabled;
                }
                return this.remoteAudioEnabled;
            },
            set: function (val) {
                if (this.isLocalStream) {
                    this.$store.dispatch("updateLocalAudioEnabled", val);
                }
                else {
                    this.remoteAudioEnabled = val;
                }
            }
        } }),
    methods: __assign(__assign({}, mapActions(["toggleChatPanelOpened"])), { toggleVideo: function () {
            if (this.isLocalStream && this.sharingScreenOnly) {
                // This is for backward compatibility with WC < 15.1
                if (this.supportSimultaneousScreen) {
                    Screenshare.enableScreenAndVideo(this.$store, this.$socket);
                }
                else {
                    Screenshare.stopScreen(this.$store, this.$socket);
                }
                return;
            }
            if (!this.source)
                return;
            this.videoEnabled = toggleTrack(this.source.getVideoTracks.bind(this.source));
        },
        toggleAudio: function () {
            if (!this.source)
                return;
            this.audioEnabled = toggleTrack(this.source.getAudioTracks.bind(this.source));
            if (this.$store.getters.appState !== "connected")
                return false;
            if (!this.isLocalStream)
                return false;
            var messageJson = {
                subaction: "audioMuteStateChanged",
                value: !this.audioEnabled
            };
            this.$socket.send("broadcastToPeers", messageJson);
        } }),
    mounted: function () {
        var _this = this;
        var params = SearchParams.parse(window.location.search.replace(/^\?/, ""));
        var bitrate = params.find(function (param) { return param.name === "show_bitrate"; });
        if (!this.isLocalStream && bitrate) {
            this.showBitrate = true;
            this.peer.onBitrateChange = function (bitrate) {
                _this.bitrate = bitrate;
            };
        }
        // Tally and audio mute update
        this.$socket.on("gotBroadcastToAll", function (payload) {
            if (payload.subaction === "tallyStateChanged") {
                if (payload.tallyPeerIdentifier !== _this.id)
                    return;
                _this.isLive = payload.value;
            }
            else if (payload.subaction === "screenTallyStateChanged") {
                if (payload.peersIdentifier !== _this.id)
                    return;
                _this.$store.dispatch("updateScreenTallyActive", payload.value);
            }
            else if (payload.subaction === "audioMuteStateChanged") {
                if (payload.peersIdentifier !== _this.id)
                    return;
                _this.isAudioMuted = payload.value;
            }
        });
        this.$socket.on("gotDirectMessage", function (payload) {
            if (payload.subaction === "tallyStateChanged") {
                if (payload.tallyPeerIdentifier !== _this.id)
                    return;
                _this.isLive = payload.value;
            }
            else if (payload.subaction === "screenTallyStateChanged") {
                if (payload.peersIdentifier !== _this.id)
                    return;
                _this.$store.dispatch("updateScreenTallyActive", payload.value);
            }
            else if (payload.subaction === "audioMuteStateChanged") {
                if (payload.peersIdentifier !== _this.id)
                    return;
                _this.isAudioMuted = payload.value;
            }
        });
        attachCanPlayEvent.call(this);
        if (!this.source) {
            return;
        }
        var audioTrack = this.source.getAudioTracks()[0];
        if (audioTrack) {
            this.audioEnabled = audioTrack.enabled;
        }
        var videoTrack = this.source.getVideoTracks()[0];
        if (videoTrack) {
            this.videoEnabled = videoTrack.enabled;
        }
        setVideoElementSource(this.$el, this.source, this.isLocalStream, this.userName);
    },
};



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/Stream.vue
// module id = 334
// module chunks = 1